import { css } from "aphrodite";
import styles from "./styles";
import { Button, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AnimatedButton } from "../AnimatedButton";

const SelectBranchComponent = ({
    branches,
    webView = true,
    selectedBranchId,
    onBranchSelect = (id, name, organisationId) => {},
}) => {
    const [t] = useTranslation(["translation"]);
    const {i18n} = useTranslation(["translation"]);

    if (!branches || branches.length === 0 || !branches[0]?.id) {
        return (
            <div className={css(styles.centerEmptyContainer)}>
                <Typography variant="h6">
                    {t("No available branches have been found. Please try again later.")}
                </Typography>
            </div>
        );
    }

    return (
        <>
            <div className={css(styles.branchList)}>
                {
                    branches.map((branch, index) => (
                        <div className={css(styles.row)} key={index}>
                            <div className={css(styles.branchInfoColumn)}>
                                <Typography variant="h6">{branch['name_' + i18n.language] || branch?.name}</Typography>
                                <div className={css(styles.branchDetails)}>
                                    <Link 
                                        href={`https://www.google.com/maps/?q=${branch?.latitude},${branch?.longitude}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="hover"
                                        variant="body1"
                                    >
                                        {branch['address_' + i18n.language] || branch?.address}
                                    </Link>
                                    {branch?.phoneNumber && (
                                        <>
                                            <span className={css(styles.separator)}>,&nbsp;</span>
                                            <Link 
                                                href={`tel:${branch?.phoneNumber.replace(/[\s\-()]/g, '')}`}
                                                underline="hover"
                                                variant="body1"
                                            >
                                                {branch?.phoneNumber}
                                            </Link>
                                        </>
                                    )}
                                    {branch?.email && (
                                        <>
                                            <span className={css(styles.separator)}>,&nbsp;</span>
                                            <Link 
                                                href={`mailto:${branch?.email}`}
                                                underline="hover"
                                                variant="body1"
                                            >
                                                {branch?.email}
                                            </Link>
                                        </>
                                    )}
                                </div>
                            </div>
                            {
                                webView ? (
                                    <AnimatedButton isSelected={(branch.id === selectedBranchId)} text={t("Schedule Appointment")} onClick={() => {onBranchSelect(branch.id, branch.name, branch.organisationId)}}/>
                                ) : (
                                    <Button
                                        disableElevation
                                        disableRipple
                                        variant="contained"
                                        color={(branch.id === selectedBranchId) ? "secondary" : "primary"}
                                        className={css(styles.button)}
                                        onClick={() => {onBranchSelect(branch.id, branch.name, branch.organisationId)}}
                                    >
                                        <Typography variant="h6" color="white">
                                            {t("Schedule Appointment")}
                                        </Typography>
                                    </Button>
                                )
                            }

                        </div>
                    ))
                }
            </div>
        </>
    )
};

export default SelectBranchComponent;
